import { Tooltip, Box } from '@radix-ui/themes';
import TimeAgo from 'timeago-react';

const TimeAgoTooltip = ({ value }: { value: string }) => (
  <Box minWidth="110px">
    <Tooltip content={value}>
      <span>
        <TimeAgo datetime={value} />
      </span>
    </Tooltip>
  </Box>
);

export default TimeAgoTooltip;
